var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBaenk = function SvgBaenk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M5.188 10.092 3.78 13.5H1.438l1.406-3.408M5.952 8.24l1.58-3.826H5.187l-1.58 3.826m9.372 1.853 1.582 3.408H12.22l-1.406-3.408M12.12 8.24l-1.776-3.826H8.469l1.579 3.826m-8.61 1.913h13.125V8.24H1.438zM3.5 4.413H12V2.5H3.5z"
  })));
};
export default SvgBaenk;